(function () {
    function sendKlaviyoEvent(eventName, data, profileProperties = {}) {
        if (!window.theme.customerEmail)
            return; // Send Klaviyo event, only makes sense if a customer is logged in
        // If profile properties with value null or undefined exist, they will be deleted from the profile in Klaviyo
        const unsetProperties = [];
        Object.entries(profileProperties).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                delete profileProperties[key];
                unsetProperties.push(key);
            }
        });
        const bodyData = {
            type: 'event',
            attributes: {
                properties: data || {},
                metric: {
                    data: {
                        type: 'metric',
                        attributes: {
                            name: eventName
                        }
                    }
                },
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: window.theme.customerEmail,
                            properties: profileProperties,
                            meta: {
                                patch_properties: {
                                    unset: unsetProperties
                                }
                            }
                        }
                    }
                }
            }
        };
        if (window.theme.customerFirstName)
            bodyData.attributes.profile.data.attributes.first_name = window.theme.customerFirstName;
        if (window.theme.customerLastName)
            bodyData.attributes.profile.data.attributes.last_name = window.theme.customerLastName;
        if (!data) {
            fetch(`https://a.klaviyo.com/client/profiles/?company_id=${window.theme.tracking.klaviyoKey}`, {
                method: 'POST',
                headers: { revision: '2024-02-15', Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    data: bodyData.attributes.profile.data
                }),
                keepalive: true
            }).then(response => {
                if (!response.ok) {
                    console.error('Updating Klaviyo profile properties failed', response);
                }
            }).catch(err => {
                console.error('Error updating Klaviyo profile properties', err);
            });
        }
        else {
            fetch(`https://a.klaviyo.com/client/events/?company_id=${window.theme.tracking.klaviyoKey}`, {
                method: 'POST',
                headers: { revision: '2024-02-15', Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    data: bodyData
                }),
                keepalive: true
            }).then(response => {
                if (!response.ok) {
                    console.error('Sending Klaviyo event failed', response);
                }
            }).catch(err => {
                console.error('Error sending Klaviyo event', err);
            });
        }
    }
    /**
     * Reflects a freshly marked lesson in the lists of the same page, so the state is right without
     * a reload. The hook is `[data-lesson-id]` plus `data-completed`; a list that wants to react has
     * to derive its checkmark from that attribute in CSS. The only list a lesson page will carry is
     * the sidebar, which does not exist yet — until it does, this matches nothing.
     */
    function markLessonInLists(lessonId, completed) {
        document.querySelectorAll(`[data-lesson-id="${lessonId}"]`).forEach(element => {
            if (completed)
                element.setAttribute('data-completed', 'true');
            else
                element.removeAttribute('data-completed');
        });
    }
    function initLessonProgress(container) {
        const jsonElement = container.querySelector('[data-json="video-course"]');
        if (!jsonElement)
            return;
        const data = JSON.parse(jsonElement.innerText);
        if (data.pageType !== 'lesson')
            return;
        // Sort lessons by the correct order in the video course. The Klaviyo fields lesson_no,
        // next_uncompleted_lesson_* and first_previous_uncompleted_lesson_* hang on exactly this order.
        const categoryArray = data.categories ? [...data.categories] : [], lessonMap = new Map();
        categoryArray.push('other');
        for (let i = 0; i < categoryArray.length; i++) {
            lessonMap.set(categoryArray[i], []);
        }
        for (const [, lesson] of Object.entries(data.lessons)) {
            const category = lesson.tags.length > 0 ? lesson.tags[0] : 'other';
            lessonMap.get(category).push(lesson);
        }
        // Reorder the lessons to be sorted by category
        const sortedLessons = {};
        let lessonCounter = 0;
        for (const category of categoryArray) {
            for (const lesson of lessonMap.get(category)) {
                sortedLessons[`${lessonCounter}`] = lesson;
                lessonCounter++;
            }
        }
        data.lessons = sortedLessons;
        const completed = (data.progress && data.progress[data.videoCourseType] && data.progress[data.videoCourseType][data.lesson.id] && data.progress[data.videoCourseType][data.lesson.id].completed), checkButtons = document.querySelectorAll('[data-action="check"]'), saveProgress = function (e) {
            const target = e.target;
            const button = target.getAttribute('data-action') === 'check' ? target : target.closest('[data-action="check"]');
            button.classList.add('loading');
            const completedTimestamp = Math.floor(Date.now() / 1000);
            data.progress = data.progress || {};
            data.progress[data.videoCourseType] = data.progress[data.videoCourseType] || {};
            data.progress[data.videoCourseType][data.lesson.id] = data.progress[data.videoCourseType][data.lesson.id] || {};
            if (data.progress[data.videoCourseType][data.lesson.id].completed) {
                data.progress[data.videoCourseType][data.lesson.id].completed = false;
            }
            else {
                data.progress[data.videoCourseType][data.lesson.id].completed = true;
                data.progress[data.videoCourseType][data.lesson.id].completedTimestamp = completedTimestamp;
            }
            const callback = (success) => {
                button.classList.remove('loading');
                const lessonProgress = data.progress[data.videoCourseType][data.lesson.id];
                if (!success) {
                    // Roll the mutation above back once, not once per check button
                    lessonProgress.completed = !lessonProgress.completed;
                    return;
                }
                checkButtons.forEach((checkButton) => {
                    checkButton.setAttribute('data-completed', `${lessonProgress.completed}`);
                });
                markLessonInLists(data.lesson.id, lessonProgress.completed);
            };
            window.cmq = window.cmq || [];
            window.cmq.push({ path: 'coaching/progress', id: data.customer, value: data.progress, callback: callback });
            document.dispatchEvent(new CustomEvent('customer:metafield:save'));
            // Video course progress tracking
            const videoCourseProgressEvent = {
                coaching_name: data.meta.videoCourseTitle,
                category_name: data.meta.categoryTitle,
                lesson_name: data.meta.lessonTitle,
                completed_timestamp: data.progress[data.videoCourseType][data.lesson.id].completed ? data.progress[data.videoCourseType][data.lesson.id].completedTimestamp : null,
                first_previous_uncompleted_lesson_title: null,
                first_previous_uncompleted_lesson_url: null,
                next_uncompleted_lesson_title: null,
                next_uncompleted_lesson_url: null,
                lesson_no: null,
                coaching_completed_lessons: 0,
                category_completed_lessons: 0,
                coaching_total_lessons: 0,
                category_total_lessons: 0
            };
            let found = false;
            Object.entries(data.lessons).forEach(([index, lesson]) => {
                if (lesson.id === data.lesson.id) {
                    videoCourseProgressEvent.lesson_no = parseInt(index) + 1;
                    found = true;
                }
                else if (!found && !videoCourseProgressEvent.first_previous_uncompleted_lesson_title && (!data.progress[data.videoCourseType][lesson.id] || !data.progress[data.videoCourseType][lesson.id].completed)) {
                    videoCourseProgressEvent.first_previous_uncompleted_lesson_title = lesson.title;
                    videoCourseProgressEvent.first_previous_uncompleted_lesson_url = lesson.url;
                }
                else if (found && !videoCourseProgressEvent.next_uncompleted_lesson_title && (!data.progress[data.videoCourseType][lesson.id] || !data.progress[data.videoCourseType][lesson.id].completed)) {
                    videoCourseProgressEvent.next_uncompleted_lesson_title = lesson.title;
                    videoCourseProgressEvent.next_uncompleted_lesson_url = lesson.url;
                }
                if (data.meta.categoryTitle === lesson.tags[0]) {
                    videoCourseProgressEvent.category_total_lessons++;
                    if (data.progress[data.videoCourseType][lesson.id] && data.progress[data.videoCourseType][lesson.id].completed)
                        videoCourseProgressEvent.category_completed_lessons++;
                }
                videoCourseProgressEvent.coaching_total_lessons++;
                if (data.progress[data.videoCourseType][lesson.id] && data.progress[data.videoCourseType][lesson.id].completed)
                    videoCourseProgressEvent.coaching_completed_lessons++;
            });
            const profileProperties = {}, prefix = data.meta.videoCourseHandle;
            if (data.progress[data.videoCourseType][data.lesson.id].completed) {
                profileProperties[`${prefix}_last_completed_lesson_name`] = videoCourseProgressEvent.lesson_name;
                profileProperties[`${prefix}_last_completed_lesson_timestamp`] = videoCourseProgressEvent.completed_timestamp;
                profileProperties[`${prefix}_last_completed_lesson_category`] = videoCourseProgressEvent.category_name;
                profileProperties[`${prefix}_last_completed_lesson_no`] = videoCourseProgressEvent.lesson_no;
                profileProperties[`${prefix}_first_previous_uncompleted_lesson_title`] = videoCourseProgressEvent.first_previous_uncompleted_lesson_title;
                profileProperties[`${prefix}_first_previous_uncompleted_lesson_url`] = videoCourseProgressEvent.first_previous_uncompleted_lesson_url;
                profileProperties[`${prefix}_next_uncompleted_lesson_title`] = videoCourseProgressEvent.next_uncompleted_lesson_title;
                profileProperties[`${prefix}_next_uncompleted_lesson_url`] = videoCourseProgressEvent.next_uncompleted_lesson_url;
            }
            profileProperties[`${prefix}_total_lessons`] = videoCourseProgressEvent.coaching_total_lessons;
            profileProperties[`${prefix}_total_completed_lessons`] = videoCourseProgressEvent.coaching_completed_lessons;
            sendKlaviyoEvent('Coaching Progress', data.progress[data.videoCourseType][data.lesson.id].completed ? videoCourseProgressEvent : null, profileProperties);
        };
        checkButtons.forEach((button) => {
            if (completed)
                button.setAttribute('data-completed', "true");
            button.style.display = '';
            button.addEventListener('click', saveProgress);
        });
        // Save progress when video was watched to the end
        if (data.wistiaId) {
            const player = document.querySelector(`wistia-player[media-id="${data.wistiaId}"]`);
            const onSecondChange = (e) => {
                if (e.detail.second / player.duration * 100 < data.videoThreshold)
                    return;
                player.removeEventListener('second-change', onSecondChange);
                const completed = (data.progress && data.progress[data.videoCourseType] && data.progress[data.videoCourseType][data.lesson.id] && data.progress[data.videoCourseType][data.lesson.id].completed);
                if (!completed)
                    checkButtons[0].click();
            };
            player.addEventListener('second-change', onSecondChange);
        }
    }
    initLessonProgress(document.querySelector('.PageContainer'));
})();
/**
 * Lesson duration badges
 *
 * There is no duration metafield, so the value comes from Wistia. Fetching it for every card of a
 * course with 29 lessons at page load would be wasteful, so each badge waits until its card comes
 * close to the viewport. The result is cached in localStorage because the duration of a media
 * never changes.
 */
(function () {
    const badges = Array.from(document.querySelectorAll('[data-lesson-duration][data-wistia-id]'));
    if (!badges.length)
        return;
    const CACHE_PREFIX = 'videoCourseLessonDuration_';
    let suffix = 'min';
    const settingsElement = badges[0].closest('[data-section-settings]');
    if (settingsElement) {
        try {
            suffix = JSON.parse(settingsElement.getAttribute('data-section-settings')).durationSuffix || suffix;
        }
        catch (e) {
            console.error('Error parsing video course section settings', e);
        }
    }
    const readCache = (mediaId) => {
        try {
            const cached = localStorage.getItem(CACHE_PREFIX + mediaId);
            if (!cached)
                return null;
            const seconds = parseFloat(cached);
            return isNaN(seconds) ? null : seconds;
        }
        catch (e) {
            return null;
        }
    };
    const writeCache = (mediaId, seconds) => {
        try {
            localStorage.setItem(CACHE_PREFIX + mediaId, `${seconds}`);
        }
        catch (e) { } // Private browsing modes reject writes; the badge still works, it is just not cached
    };
    const display = (badge, seconds) => {
        const total = Math.round(seconds), minutes = Math.floor(total / 60), remainingSeconds = total % 60;
        badge.textContent = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} ${suffix}`;
    };
    const loadDuration = (badge) => {
        const mediaId = badge.getAttribute('data-wistia-id');
        const cached = readCache(mediaId);
        if (cached !== null) {
            display(badge, cached);
            return;
        }
        fetch(`https://fast.wistia.com/embed/medias/${mediaId}.json`)
            .then(response => response.json())
            .then(data => {
            // Unknown media ids are answered with HTTP 200 and {"error":true,"iframe":true},
            // so response.ok is not a usable check here.
            if (typeof data?.media?.duration !== 'number')
                return;
            writeCache(mediaId, data.media.duration);
            display(badge, data.media.duration);
        })
            .catch(() => { });
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting)
                return;
            observer.unobserve(entry.target);
            loadDuration(entry.target);
        });
    }, { rootMargin: '200px' });
    badges.forEach(badge => observer.observe(badge));
})();
/**
 * Wistia transcript
 *
 * The transcript is a plain fetch against the captions endpoint and starts right away once the
 * player element exists on the page.
 */
(function () {
    const videoPlayer = document.querySelector('.VideoCourseLesson wistia-player');
    if (!videoPlayer)
        return;
    /**
     * Cues are fragments of a few words, so one paragraph per cue would be unreadable. Cues are
     * therefore collected until the text both ends a sentence and has reached a paragraph's worth
     * of characters. Without timestamps and without seek-on-click (decided with the design) this
     * is all the structure the transcript needs.
     */
    const buildParagraphs = (lines) => {
        const paragraphs = [];
        let current = '';
        lines.forEach(line => {
            const text = line.text.join(' ').trim();
            if (!text)
                return;
            current = current ? `${current} ${text}` : text;
            if (current.length >= 400 && /[.!?]["'“”]?$/.test(current)) {
                paragraphs.push(current);
                current = '';
            }
        });
        if (current)
            paragraphs.push(current);
        return paragraphs;
    };
    const renderTranscript = () => {
        const mediaId = videoPlayer.getAttribute('media-id'), container = document.querySelector('[data-transcript-element="container"]'), trigger = document.querySelector('[data-transcript-element="trigger"]');
        if (!mediaId || !container || !trigger)
            return;
        const body = container.querySelector('[data-transcript-element="body"]');
        if (!body)
            return;
        fetch(`https://fast.wistia.com/embed/captions/${mediaId}.json`)
            .then(response => response.ok ? response.json() : null) // An unknown media id answers 404
            .then((data) => {
            // Not captions[0]: some medias carry an empty English track in front of the German one.
            // A track without cues is what most lessons have, and it is not a transcript.
            const track = (data?.captions || []).filter(caption => {
                return caption.bcp47LanguageTag === 'de' && caption.hash && caption.hash.lines && caption.hash.lines.length > 0;
            })[0];
            if (!track)
                return;
            const paragraphs = buildParagraphs(track.hash.lines);
            if (!paragraphs.length)
                return;
            paragraphs.forEach(paragraph => {
                const element = document.createElement('p');
                element.textContent = paragraph; // Caption text is external content, so never innerHTML
                body.appendChild(element);
            });
            trigger.classList.remove('none');
        })
            .catch(() => { });
    };
    // Delegated so the toggle survives a re-render in the theme editor. The X inside the box and the
    // button in the action row carry the same action and both mirror the state back.
    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-action="toggle-transcript"]');
        if (!toggle)
            return;
        const container = document.getElementById(toggle.getAttribute('aria-controls') || '');
        if (!container)
            return;
        const expanded = container.classList.contains('none');
        container.classList.toggle('none', !expanded);
        container.setAttribute('aria-hidden', `${!expanded}`);
        document.querySelectorAll('[data-action="toggle-transcript"]').forEach(element => {
            element.setAttribute('aria-expanded', `${expanded}`);
        });
        if (expanded)
            container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    renderTranscript();
})();
/**
 * Lesson module navigation
 *
 * The sidebar and the mobile bottom sheet are the same DOM node, repositioned in video-course.css:
 * a second copy would have to be kept in sync with the optimistic update above, which addresses
 * lessons by `data-lesson-id`. Below 768px the node is a fixed bar that expands into the sheet.
 */
(function () {
    if (!document.querySelector('.VideoCourseLessonNav'))
        return;
    const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;
    // Only relevant when this sheet was the one that locked the page, see setExpanded()
    let scrollLockedByNav = false;
    // The collapsed bar is the sticky bottom element of the lesson page, so it publishes the height
    // the rest of the theme reserves space with (`snippets/show-more.liquid`,
    // `sections/video-with-text.liquid`) — same contract as the sticky add to cart bar. While the
    // sheet is open the bar is display: none and would measure 0, so the last value stands until it
    // collapses again.
    const publishBarHeight = () => {
        if (document.querySelector('.VideoCourseLessonNav[data-expanded="true"]'))
            return;
        const bar = document.querySelector('.VideoCourseLessonNav__Bar');
        document.documentElement.style.setProperty('--sticky-cta-height', isDesktop() || !bar ? '0' : `${bar.offsetHeight}px`);
    };
    const setExpanded = (nav, expanded) => {
        nav.setAttribute('data-expanded', `${expanded}`);
        nav.querySelector('.VideoCourseLessonNav__Bar')?.setAttribute('aria-expanded', `${expanded}`);
        if (expanded) {
            window.pageOverlay?.open(nav.id, () => setExpanded(nav, false));
            // Dom.disableScroll() is not exported from theme.ts, so the class it maintains is set
            // directly. Taking it only when it is free keeps a drawer that was open first intact; the
            // reverse order — a drawer opening and closing over the sheet — drops the lock until the
            // next toggle, which is the same state as not locking at all.
            scrollLockedByNav = !document.documentElement.classList.contains('no-scroll');
            if (scrollLockedByNav)
                document.documentElement.classList.add('no-scroll');
            return;
        }
        window.pageOverlay?.close(nav.id);
        if (scrollLockedByNav)
            document.documentElement.classList.remove('no-scroll');
        scrollLockedByNav = false;
        publishBarHeight();
    };
    // Delegated so the sheet keeps working after the theme editor re-renders the section
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-action="toggle-lesson-nav"]');
        if (!trigger)
            return;
        const nav = trigger.closest('.VideoCourseLessonNav');
        if (!nav)
            return;
        setExpanded(nav, nav.getAttribute('data-expanded') !== 'true');
    });
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape')
            return;
        const nav = document.querySelector('.VideoCourseLessonNav[data-expanded="true"]');
        if (nav)
            setExpanded(nav, false);
    });
    const syncToViewport = () => {
        if (isDesktop()) {
            // Crossing into the two-column layout leaves the sheet state behind
            const nav = document.querySelector('.VideoCourseLessonNav[data-expanded="true"]');
            if (nav)
                setExpanded(nav, false);
        }
        publishBarHeight();
    };
    publishBarHeight();
    window.addEventListener('resize', syncToViewport);
})();
/**
 * Sticky tab bar border
 *
 * The bar sticks at `top: header-height - 1px`, so once it is stuck its first pixel row lies
 * behind the header and the intersection ratio drops below 1. The observer clips the viewport at
 * the header's bottom edge to detect exactly that. The border is a data attribute for the
 * stylesheet because CSS has no cross-browser way to query the stuck state yet.
 */
(function () {
    let observer;
    const init = () => {
        observer?.disconnect();
        const tabBar = document.querySelector('.VideoCourse__TabBar');
        if (!tabBar)
            return;
        // The header height changes with the breakpoint, and rootMargin cannot take a variable
        const observe = () => {
            observer?.disconnect();
            const stickyTop = parseFloat(getComputedStyle(tabBar).top) || 0;
            observer = new IntersectionObserver(([entry]) => {
                tabBar.setAttribute('data-stuck', `${entry.intersectionRatio < 1}`);
            }, { rootMargin: `-${stickyTop + 1}px 0px 0px 0px`, threshold: [1] });
            observer.observe(tabBar);
        };
        observe();
        window.addEventListener('resize', observe, { passive: true });
    };
    init();
    document.addEventListener('shopify:section:load', init);
})();
export {};
